import React from "react";
import { Modal, ModalHeader, ModalBody, } from "reactstrap";
import "font-awesome/css/font-awesome.min.css";

const ModalHeaderComponent = ({ errorMsg, logDataFrom }) => {
    if (errorMsg.type === "success") {
        return <h5 className="text-success">
            {logDataFrom} Validation Success {errorMsg.logMessage}
        </h5>
    }
    return <h5 className="text-danger">{errorMsg.logMessage}</h5>
}
const LogModel = ({ modal, toggle, errorMsg, logDataFrom, theadData, tbodyData }) => {
    return <Modal
        isOpen={modal}
        toggle={toggle}
        modalTransition={{ timeout: 300 }}
        className="modalwrap"
    >
        <ModalHeader toggle={toggle}>
            <ModalHeaderComponent errorMsg={errorMsg} logDataFrom={logDataFrom} />
        </ModalHeader>
        <ModalBody>
            <table className="table-bordered">
                <thead className="head-level-1">
                    <tr>
                        {theadData?.map((heading) => <th>{heading}</th>)}
                    </tr>
                </thead>
                <tbody>
                    {tbodyData?.map((row, index) => {
                        return (
                            <tr key={index}>
                                {theadData?.map((key, index) => {
                                    if (
                                        typeof row[key] === "object" &&
                                        row[key] !== null
                                    ) {
                                        const objRes = row[key];
                                        return (
                                            <td key={index}>
                                                {objRes.length !== 0 && (
                                                    <table style={{ margin: "0 auto", }} >
                                                        <thead className="head-level-2">
                                                            <tr>
                                                                {Object.keys(objRes[0]).map(
                                                                    (j, i) => (
                                                                        <th key={i}>{j}</th>
                                                                    )
                                                                )}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {Object.entries(objRes).map(
                                                                ([key, value]) => {
                                                                    return (
                                                                        <tr key={key}>
                                                                            {Object.values(value).map(
                                                                                (j, i) => (
                                                                                    <td key={i}>
                                                                                        {typeof j === "object" && j !== null ? (
                                                                                            <div>
                                                                                                <table>
                                                                                                    <thead className="head-level-3">
                                                                                                        <tr>
                                                                                                            {j[0] && Object.keys(j[0]).map(
                                                                                                                (v) => (
                                                                                                                    <th key={v}>{v}</th>
                                                                                                                )
                                                                                                            )}
                                                                                                        </tr>
                                                                                                    </thead>
                                                                                                    <tbody>
                                                                                                        {j.map((item, index) => (
                                                                                                            <tr key={index}>
                                                                                                                {Object.values(item).map((a, b) => (
                                                                                                                    <td key={b}>{a}</td>
                                                                                                                )
                                                                                                                )}
                                                                                                            </tr>
                                                                                                        )
                                                                                                        )}
                                                                                                    </tbody>
                                                                                                </table>
                                                                                            </div>
                                                                                        ) : (
                                                                                            j
                                                                                        )}
                                                                                    </td>
                                                                                )
                                                                            )}
                                                                        </tr>
                                                                    );
                                                                }
                                                            )}
                                                        </tbody>
                                                    </table>
                                                )}
                                            </td>
                                        );
                                    } else if (row[key] === null) {
                                        return <td> </td>;
                                    } else {
                                        return <td>{`${row[key]}`} </td>;
                                    }
                                })}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </ModalBody>
    </Modal>
}

export default LogModel